import { gql } from '@apollo/client';

export const UpdateServices = gql`
mutation UpdateServices($idStore: ID!, $content: contentServices!) {
  updateServices(idStore: $idStore, content: $content) {
    status
  }
}
`;